import {
  Drawer, DrawerBody, DrawerHeader, DrawerCloseButton, DrawerOverlay, DrawerContent,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton,
  Box, Flex, Text, Input, Image, Badge, InputGroup, InputLeftElement, Popover, PopoverTrigger,
  PopoverContent, Button, PopoverBody, useDisclosure, PopoverCloseButton, Center, Spinner,
  Grid, Checkbox,
  AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay,
} from '@chakra-ui/react';
import { CustomTable, CustomToast } from "../../../../components";
import { useFetch } from "../../../../hooks/useFetch";
import MyDiv from './attendanceList.style';
import FilterIcon from '../../../../assets/images/Filter.svg';
import SortIcon from '../../../../assets/images/SortIcon.svg';
import { CalendarIcon, RepeatClockIcon, SearchIcon } from '@chakra-ui/icons';
import Calendar from 'react-calendar';
import { useEffect, useState, useRef } from 'react';
import { CustomPagination, FilterPopover } from '../../../../components';
import AttendanceListCard from '../AttendanceCard/attendanceListCard';
import { AttendanceRecord, getStatusClass, sortMapping, sortOptions, Props, getPayrollStatusName, getPayrollStatusClass, getSourceBadgeClass } from './modal';
import { Column } from '../../../../components/CustomTable/customTable';
import { showDate, showDateTime } from '../../../../utilities/helper';
import { useAuth } from '../../../../hooks/useAuth';

const AttendanceList = ({
  handlePageClick, pageCount, attendanceData, selectedDate, setSelectedDate, searchTerm, setSearchTerm,
  lazyParams, setLazyParams, loading, totalCount, setRowsPerPage, filter, setSelectedItems, setAttendanceFilter,
}: Props) => {
  // Separate open/close state for each popover
  const { isOpen, onOpen, onClose } = useDisclosure(); // calendar
  const sortPop = useDisclosure();
  const filterPop = useDisclosure();

  const [selected, setSelected] = useState<string>(sortOptions[0]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedEmp, setSelectedEmp] = useState<AttendanceRecord | null>(null);
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [modelopen, setModelOpen] = useState(false);
  const [punchLogs, setPunchLogs] = useState<any>();
  const [emp, setEmp] = useState<AttendanceRecord | null>(null);
  const [fethchAttendanceModal, setFetchAttendanceModal] = useState(false);
  const [assignBranches, setAssignBranches] = useState<any[]>([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [selectedBranches, setSelectedBranches] = useState<number[]>([]);
  const [jobId, setJobId] = useState<string | null>(null);
  const [jobState, setJobState] = useState<string>('');
  const { hasPermission } = useAuth();
  const [breakModalOpen, setBreakModalOpen] = useState(false);
  const [selectedBreaks, setSelectedBreaks] = useState<any[]>([]);
  const [selectedEmpName, setSelectedEmpName] = useState('');
  const [branchesLoading, setBranchesLoading] = useState(false);
  const [jobStats, setJobStats] = useState<{ processed?: number; skipped?: number; pending?: number; errors?: number; message?: string }>({});
  const pollIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const { isOpen: isConfirmOpen, onOpen: onConfirmOpen, onClose: onConfirmClose } = useDisclosure();
  const cancelRef = useRef<HTMLButtonElement>(null);

  const handleSelect = (option: string) => {
    setSelected(option);
    const { field, order } = sortMapping[option];
    setLazyParams((prev: any) => ({
      ...prev,
      sortField: field,
      sortOrder: order,
      page: 0,
    }));
    sortPop.onClose();
  };

  // Local-time yyyy-mm-dd (avoids the UTC shift of toISOString)
  const formatDate = (date: Date) => {
    const offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return offsetDate.toISOString().split('T')[0];
  };

  // CHANGED: latest selectable date for reprocess = today (local time), no future dates.
  // Shifts of today that have not ended yet are skipped by the backend and can be
  // reprocessed later.
  const today = formatDate(new Date());

  const handleview = async (emp: AttendanceRecord) => {
    setEmp(emp);
    setModelOpen(true);
    const response = await fetchApi("Hrlense_Attendance/punchLogs", "GET", "", `employeeId=${emp?.employeeId}&date=${formatDate(selectedDate)}`);
    if (response) setPunchLogs(response);
  };

  const loadAssignBranches = async () => {
    setBranchesLoading(true);
    const response = await fetchApi("DropDown/GetAssignBranches", "GET");
    if (response) setAssignBranches(response);
    setBranchesLoading(false);
  };

  useEffect(() => {
    if (fethchAttendanceModal) loadAssignBranches();
  }, [fethchAttendanceModal]);

  const toggleBranch = (id: number) => {
    setSelectedBranches(prev => prev.includes(id) ? prev.filter(b => b !== id) : [...prev, id]);
  };

  const toggleAll = () => {
    setSelectedBranches(prev => prev.length === assignBranches.length ? [] : assignBranches.map((b: any) => b.branch_Id));
  };

  const handleReprocessClick = () => {
    if (!fromDate || !toDate)
      return addToast({ message: 'Select both dates', status: 'warning' });

    if (fromDate > toDate)
      return addToast({ message: '"From" must be before "To"', status: 'warning' });

    // CHANGED: safety net, future dates are never allowed (today is allowed)
    if (fromDate > today || toDate > today)
      return addToast({ message: 'Future dates are not allowed', status: 'warning' });

    onConfirmOpen();
  };

  const handleReprocess = async () => {
    onConfirmClose();

    const params = new URLSearchParams();
    params.append('from', fromDate);
    params.append('to', toDate);

    if (selectedBranches.length > 0) {
      selectedBranches.forEach(b => {
        params.append('branchId', b.toString());
      });
    }
    const response = await fetchApi('ManuallyFetchAttendance/reprocess-attendance', 'POST', '', params.toString());
    if (response?.jobId) {
      setJobId(response.jobId);
      setJobState('running');
      pollJob(response.jobId);
    }
  };

  const getDayCount = () => {
    if (!fromDate || !toDate) return 0;
    const diff = new Date(toDate).getTime() - new Date(fromDate).getTime();
    return Math.floor(diff / 86400000) + 1;
  };

  const getSelectedBranchNames = () => {
    if (selectedBranches.length === 0) return 'all your assigned branches';
    return assignBranches
      .filter((b: any) => selectedBranches.includes(b.branch_Id))
      .map((b: any) => b.branch_Name)
      .join(', ');
  };

  const pollJob = (id: string) => {
    if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);

    pollIntervalRef.current = setInterval(async () => {
      const res = await fetchApi(`ManuallyFetchAttendance/job-status/${id}`, 'GET');
      if (res) {
        setJobState(res.state);
        setJobStats({ processed: res.processed, skipped: res.skipped, pending: res.pending, errors: res.errors, message: res.message });

        if (res.state === 'done' || res.state === 'failed') {
          if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
          pollIntervalRef.current = null;

          if (res.state === 'done') {
            // CHANGED: tell the user when some shifts were left for later
            const pendingNote = res.pending > 0 ? ` (${res.pending} not ended yet, left for later)` : '';
            addToast({ message: `Done — ${res.processed} records processed${pendingNote}`, status: 'success' });
            resetReprocessModal();
          } else {
            addToast({ message: `Failed: ${res.message}`, status: 'error' });
          }
        }
      }
    }, 3000);
  };

  useEffect(() => {
    return () => {
      if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
    };
  }, []);

  const resetReprocessModal = () => {
    setFetchAttendanceModal(false);
    setFromDate('');
    setToDate('');
    setSelectedBranches([]);
    setJobId(null);
    setJobState('');
    setJobStats({});
  };

  const handleModalClose = () => {
    if (jobState === 'running') {
      addToast({ message: 'Reprocessing is in progress. Please wait until it completes.', status: 'warning' });
      return;
    }
    resetReprocessModal();
  };

  return (
    <MyDiv>
      <Box className="page_wrapper ">
        <Flex className="page_heading flex_header">
          <Text className="font-poppins text_medium text_lg">Attendance Employee List</Text>
          <Flex className="filter_section" flexWrap="wrap" gap={3} align="center">
            {hasPermission("AttendanceSheet", "ReProcessAttendance") && (
              <Button variant="outline" padding={1} onClick={() => { setFetchAttendanceModal(true); loadAssignBranches(); }} leftIcon={<RepeatClockIcon />}>
                <Text className="font-poppins text_sm text_regular">Reprocess Attendance</Text>
              </Button>
            )}
            <InputGroup maxW="200px">
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.400" />
              </InputLeftElement>
              <Input placeholder="Search name" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
            </InputGroup>

            {/* Calendar */}
            <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} placement="bottom-end">
              <PopoverTrigger>
                <Button leftIcon={<CalendarIcon />} padding={1} variant="outline">
                  <Text className="font-poppins text_sm text_regular">{selectedDate.toDateString()}</Text>
                </Button>
              </PopoverTrigger>
              <PopoverContent w="auto">
                <PopoverBody p={2} display="flex" justifyContent="center">
                  <Calendar
                    value={selectedDate}
                    onChange={(value) => {
                      if (value instanceof Date) {
                        setSelectedDate(value);
                        onClose();
                      }
                    }}
                    maxDate={new Date()}
                  />
                </PopoverBody>
              </PopoverContent>
            </Popover>

            {/* Filter */}
            <Popover isOpen={filterPop.isOpen} onOpen={filterPop.onOpen} onClose={filterPop.onClose} placement="bottom-end" closeOnBlur>
              <PopoverTrigger>
                <Image src={FilterIcon} alt="Filter" className="icon_btn" cursor="pointer" />
              </PopoverTrigger>
              <FilterPopover
                filter={filter}
                onApplyFilter={(filters) => {
                  const _filter: Record<string, number[]> = {};
                  Object.keys(filters).forEach((key) => {
                    if (filters[key].length > 0) {
                      _filter[key.replace(" ", "")] = filters[key];
                    }
                  });
                  setAttendanceFilter?.({});
                  setSelectedItems(_filter);
                  setLazyParams((prev: any) => ({ ...prev, page: 0, first: 0 }));
                  filterPop.onClose();
                }}
              />
            </Popover>

            {/* Sort */}
            <Popover isOpen={sortPop.isOpen} onOpen={sortPop.onOpen} onClose={sortPop.onClose} placement="bottom-end" closeOnBlur>
              <PopoverTrigger>
                <Image src={SortIcon} alt="Sort" className="icon_btn" cursor="pointer" />
              </PopoverTrigger>
              <PopoverContent w="270px" borderRadius="10px" boxShadow="md" textAlign="center">
                <Box px={4} py={2} borderBottom="1px solid #eee">
                  <Text className="font-poppins text_sm text_medium" textAlign="center" color="#00000080">Sort By</Text>
                  <PopoverCloseButton top="8px" right="12px" />
                </Box>
                <PopoverBody p={0}>
                  {sortOptions.map((option) => (
                    <Box key={option} px={4} py={2} cursor="pointer" bg={selected === option ? '#EBEBEB' : 'white'} _hover={{ bg: '#EBEBEB' }} onClick={() => handleSelect(option)}>
                      <Text className="font-poppins font_dark" fontSize="14px" fontWeight={selected === option ? 600 : 500}>{option}</Text>
                    </Box>
                  ))}
                </PopoverBody>
              </PopoverContent>
            </Popover>
          </Flex>
        </Flex>

        <Box position="relative" minH="300px">
          {loading ? (
            <Center position="absolute" top={0} left={0} right={0} bottom={0}>
              <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
            </Center>
          ) : (
            <>
              <CustomTable value={attendanceData.records}>
                <Column header="S. No" body={(_, index) => index + 1} />
                <Column header="Emp. Code" body={(emp: AttendanceRecord) => (
                  <Badge variant="subtle" className="empId font-poppins text_sm text_regular"
                    onClick={() => { setSelectedEmp(emp); setDrawerOpen(true); }}>
                    {emp.employee_Code}
                  </Badge>
                )}
                />
                <Column header="Name" body={(emp: AttendanceRecord) => (
                  <Badge colorScheme="green" variant="subtle" className="empId font-poppins text_sm text_regular" onClick={() => handleview(emp)}>
                    {emp.employeeName}
                  </Badge>
                )}
                />
                <Column header="Check IN"
                  body={(emp: AttendanceRecord) => {
                    const isEmpty = emp.startTime === "00:00:00";
                    return (
                      <Text className="font-poppins text_sm" bg={emp.isLate ? "yellow.100" : "transparent"}
                        color={emp.isLate ? "yellow.500" : "inherit"} px={2} py={1} borderRadius="4px"
                        display="inline-block">
                        {isEmpty ? '—' : emp.startTime}
                      </Text>
                    );
                  }}
                />
                <Column header="Check OUT" body={(emp: AttendanceRecord) =>
                  !emp.endTime || emp.endTime === "00:00:00" ? "—" : emp.endTime}
                />
                <Column header="Break Time" body={(emp: AttendanceRecord) => (
                  <Badge
                    colorScheme="orange" cursor="pointer" px={3} py={1} borderRadius="md" onClick={() => {
                      setSelectedBreaks(emp.breakDetails || []);
                      setSelectedEmpName(emp.employeeName);
                      setBreakModalOpen(true);
                    }}
                  >
                    {emp.totalBreakTime || "00:00"}
                  </Badge>
                )}
                />
                <Column header="Date" body={(emp: AttendanceRecord) => (showDate(emp.date))} />
                <Column header="Status" body={(emp: AttendanceRecord) => (
                  <Text as="span" className={`font-poppins text_sm text_medium ${getStatusClass(emp.status)}`}>{emp.status_Name}</Text>
                )}
                />
                <Column header="Source" body={(emp: AttendanceRecord) => {
                  const src = emp.source || "Automatic";
                  return (
                    <Text as="span" className={`font-poppins text_sm text_medium ${getSourceBadgeClass(src)}`}>
                      {src}
                    </Text>
                  );
                }}
                />
                {hasPermission("AttendanceSheet", "ViewPayrollStatus") && (
                  <Column header="Payroll Status" body={(emp: AttendanceRecord) => (
                    <Text as="span" className={`font-poppins text_sm text_medium ${getPayrollStatusClass(emp.payroll_Attendance_Status)}`}>{getPayrollStatusName(emp.payroll_Attendance_Status)}</Text>
                  )}
                  />
                )}
              </CustomTable>
            </>
          )}
        </Box>
      </Box>
      <CustomPagination pageCount={pageCount} rowsPerPageOptions={[20, 50, 200, 500]} handlePageClick={handlePageClick} setRowsPerPage={setRowsPerPage} rowsPerPage={lazyParams.rows} totalRecords={totalCount} currentPage={lazyParams.page} />

      <Drawer isOpen={drawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="md">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">Employee Attendance</DrawerHeader>
          <DrawerBody>
            <AttendanceListCard employeeId={selectedEmp?.employeeId} date={selectedDate} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <Modal isOpen={modelopen} onClose={() => { setModelOpen(false); setPunchLogs(null); }} size="lg" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalHeader mt={4}>Punch Logs – {emp?.employeeName} ({selectedDate.toDateString()})</ModalHeader>
          <ModalBody>
            <CustomTable value={punchLogs?.punchLogs || []} loading={false} emptyMessage="No punches found for this date.">
              <Column header="ID" body={(_, index) => index + 1} />
              <Column header="Punch Time" body={(log: any) => new Date(log.punchTime).toLocaleTimeString()} />
              <Column<any> header="Punch Type" body={(log: any) => log.punchType?.toUpperCase()} />
            </CustomTable>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={fethchAttendanceModal} onClose={handleModalClose} size="4xl" isCentered motionPreset="slideInBottom">
        <ModalOverlay />
        <ModalContent maxW="900px" mx="auto" borderRadius="4px">
          <ModalHeader mt={4}>Reprocess attendance</ModalHeader>
          <ModalBody pb={6}>
            <Text fontSize="sm" color="gray.500" mb={1}>Select a date range to delete existing records and recalculate from fresh punch data.</Text>
            {/* CHANGED: explain how today / unfinished shifts are handled */}
            <Text fontSize="xs" color="gray.400" mb={4}>Today can be selected. Shifts that have not ended yet (including grace time) are skipped and left unchanged — run again after the shift ends.</Text>
            <Flex gap={4} mb={5}>
              <Box flex={1}>
                <Text fontSize="xs" color="gray.500" mb={1}>From date</Text>
                <Input
                  type="date"
                  value={fromDate}
                  max={today}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (v > today) {
                      return addToast({ message: "From date cannot be in the future", status: "error" });
                    }
                    setFromDate(v);
                    if (toDate && v > toDate) setToDate("");
                  }}
                />
              </Box>

              <Box flex={1}>
                <Text fontSize="xs" color="gray.500" mb={1}>To date</Text>
                <Input
                  type="date"
                  value={toDate}
                  min={fromDate || undefined}
                  max={today}
                  isDisabled={!fromDate}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (!v) { setToDate(""); return; }
                    if (v < fromDate) {
                      return addToast({ message: "To date cannot be before From date", status: "error" });
                    }
                    if (v > today) {
                      return addToast({ message: "To date cannot be in the future", status: "error" });
                    }
                    setToDate(v);
                  }}
                />
              </Box>
            </Flex>

            <Flex justify="space-between" align="center" mb={2}>
              <Text fontSize="xs" color="gray.500">Filter by branch <Text as="span" color="gray.400">(optional)</Text></Text>
              <Button size="xs" variant="link" colorScheme="blue" onClick={toggleAll}>
                {selectedBranches.length === assignBranches.length ? 'Clear all' : 'Select all'}
              </Button>
            </Flex>

            <Box border="1px solid" borderColor="gray.200" borderRadius="md" mb={2} minH="60px" maxH="220px" overflowY="auto">
              {branchesLoading ? (
                <Center py={4}><Spinner size="sm" color="#006838" /></Center>
              ) : (
                <Grid templateColumns="repeat(2, 1fr)">
                  {assignBranches.map((b: any) => {
                    const checked = selectedBranches.includes(b.branch_Id);
                    return (
                      <Checkbox
                        key={b.branch_Id}
                        colorScheme="green"
                        isChecked={checked}
                        onChange={() => toggleBranch(b.branch_Id)}
                        px={4} py={2} w="100%"
                        bg={checked ? "gray.50" : "white"}
                        _hover={{ bg: "gray.50" }}
                        borderBottom="1px solid"
                        borderColor="gray.100"
                      >
                        <Text fontSize="sm">{b.branch_Name}</Text>
                      </Checkbox>
                    );
                  })}
                </Grid>
              )}
            </Box>
            <Text fontSize="xs" color="gray.400" mb={4}>
              {selectedBranches.length === 0 ? 'No branch selected — will run for all your assigned branches.' : `${selectedBranches.length} branch(es) selected.`}
            </Text>

            {jobId && (
              <Flex direction="column" gap={1} mb={3}>
                <Flex align="center" gap={2}>
                  {jobState === 'running' && <Spinner size="sm" color="blue.500" />}
                  <Text fontSize="sm" color={jobState === 'done' ? 'green.600' : jobState === 'failed' ? 'red.500' : 'gray.600'}>
                    {jobState === 'running' ? 'Processing in background…' : jobState === 'done' ? 'Completed successfully' : jobState === 'failed' ? 'Failed — check logs' : ''}
                  </Text>
                </Flex>
                {(jobStats.processed !== undefined || jobStats.skipped !== undefined || jobStats.errors !== undefined) && (
                  <Text fontSize="xs" color="gray.500">
                    Processed: {jobStats.processed ?? 0} • Skipped: {jobStats.skipped ?? 0} • Pending (shift not ended): {jobStats.pending ?? 0} • Errors: {jobStats.errors ?? 0}
                  </Text>
                )}
              </Flex>
            )}

            <Flex justify="flex-end" gap={3}>
              <Button variant="outline" onClick={handleModalClose} isDisabled={jobState === 'running'}>Cancel</Button>
              <Button colorScheme="green" isLoading={jobState === 'running'} loadingText="Processing…" isDisabled={!fromDate || !toDate} onClick={handleReprocessClick}>
                Reprocess attendance
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={breakModalOpen} onClose={() => { setBreakModalOpen(false); setSelectedBreaks([]); }} size="xl" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalHeader mt={4}>Break Details – {selectedEmpName}</ModalHeader>
          <ModalBody pb={5}>
            <CustomTable value={selectedBreaks} loading={false} emptyMessage="No break details found.">
              <Column header="S. No" body={(_, index) => index + 1} />
              <Column header="Out Time" body={(row: any) => showDateTime(row.outTime)} />
              <Column header="In Time" body={(row: any) => showDateTime(row.inTime)} />
              <Column header="Break Duration" body={(row: any) => row.breakDuration} />
              <Column header="Minutes" body={(row: any) => row.totalMinutes} />
            </CustomTable>
          </ModalBody>
        </ModalContent>
      </Modal>

      <AlertDialog isOpen={isConfirmOpen} leastDestructiveRef={cancelRef} onClose={onConfirmClose} isCentered>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm attendance reprocess
            </AlertDialogHeader>

            <AlertDialogBody>
              <Text mb={3}>
                This will permanently <Text as="span" fontWeight="600" color="red.500">delete and recalculate</Text> attendance
                and punch records for <Text as="span" fontWeight="600">{getSelectedBranchNames()}</Text>,
                covering <Text as="span" fontWeight="600">{getDayCount()} day(s)</Text> from{' '}
                <Text as="span" fontWeight="600">{fromDate}</Text> to <Text as="span" fontWeight="600">{toDate}</Text>.
              </Text>
              <Text fontSize="sm" color="gray.500" mb={2}>
                This action cannot be undone. Finalized records will also be deleted and rebuilt from raw punch data.
              </Text>
              {/* CHANGED: warn that unfinished shifts are left untouched */}
              <Text fontSize="sm" color="gray.500">
                Shifts that have not ended yet (including today's) will be skipped and their existing records left unchanged.
              </Text>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onConfirmClose} variant="outline">
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleReprocess} ml={3}>
                Yes, reprocess
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </MyDiv>
  );
};

export default AttendanceList; 